// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"37":"rank","112":"stockpage","179":"main","471":"exploreReport","733":"hotBlock","757":"follow","975":"iframe"}[chunkId] || chunkId) + "." + {"37":"001de81f","112":"a0ced78c","150":"14ff468c","179":"1a2c9a7b","471":"7f54cb89","733":"1b123abf","757":"7e55772f","975":"d41322f3"}[chunkId] + ".js";
};